export default class ClassicQuizParticipationBodyModel {
  public questionId: number = 0;
  public optionId: number | null = 0;
}
